import React from "react";
import HomeNavBar from "./components/HomeNavBar";
import axios from "axios";
import { APP_URL } from "../config/api";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Modal } from "react-bootstrap";
import LoadingOverlay from "react-loading-overlay";

const PublicConferencePage = () => {
  const [link, setLink] = useState("");
  const [errorText, setErrorText] = useState("");
  const [show, setShow] = useState(false);
  const [meetingStatus, setMeetingStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const { meetingId } = useParams();
  const [details, setDetails] = useState({
    first_name: "",
    last_name: "",
    meeting_id: meetingId,
  });

  useEffect(() => {
    checkMeetingStatus();
  }, []);

  const checkMeetingStatus = () => {
    setLoading(true);
    axios
      .post(APP_URL + "/get-meeting-status", { meeting_id: meetingId })
      .then((res) => {
        if (res.data.status === 0) {
          setMeetingStatus(true);
        } else {
          setMeetingStatus(false);
          setShow(true);
        }
        setLoading(false);
      })
      .catch((error) => {
        setErrorText(error.response.statusText);
        setLoading(false);
      });
  };

  const getMeetingUrl = () => {
    setLoading(true);
    axios
      .post(APP_URL + "/get-meeting-url", details)
      .then((res) => {
        setLink(res.data.url);
        setLoading(false);
        setShow(false);
      })
      .catch((error) => {
        setErrorText(error.response.statusText);
        setLoading(false);
        setShow(false);
      });
  };

  function resizeIframe(obj){
    obj.style.height = 0;
    obj.style.height = obj.contentWindow.document.body.scrollHeight + 'px';
 }

  return (
    <LoadingOverlay active={loading} spinner text="Loading...">
      <div className="main-landing-page landing-container ">
        <HomeNavBar />
        <br />
        <div className="container-fluid">
          {errorText && (
            <div class="alert alert-danger">
              <strong>{errorText}</strong>
            </div>
          )}
          <iframe
            src={link && link}
            width={"100%"}
            height="540"
            allow="geolocation *; microphone *; camera *; display-capture *;"
            sandbox={
              "allow-same-origin allow-scripts allow-modals allow-forms allow-top-navigation"
            }
            allowFullScreen={"true"}
          ></iframe>
        </div>
        <Modal className="custom-modal" show={show} size={"lg"}>
          <Modal.Header closeButton>
            <Modal.Title>Enter Personal Details </Modal.Title>
          </Modal.Header>
          <Modal.Body className="err-model-body">
            <div className={"row"}>
              <div className="col-lg-6 mb-12">
                <div className="form-group">
                  <label className="mont-font fw-600 font-xsss">
                    First Name
                  </label>
                  <input
                    type="text"
                    required
                    className="form-control"
                    value={details.first_name}
                    onChange={(e) =>
                      setDetails({ ...details, first_name: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="col-lg-6 mb-12">
                <div className="form-group">
                  <label className="mont-font fw-600 font-xsss">
                    Last Name
                  </label>
                  <input
                    type="text"
                    required
                    className="form-control"
                    value={details.last_name}
                    onChange={(e) =>
                      setDetails({ ...details, last_name: e.target.value })
                    }
                  />
                </div>
              </div>
            </div>
            <div className={"row"}>
              <div className="col-lg-12 text-right">
                <input
                  type="button"
                  name="submit"
                  value="Submit"
                  onClick={() => getMeetingUrl()}
                  className="btn-common px-5 mt-15"
                />
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={meetingStatus}>
          <Modal.Header>
            <Modal.Title
              className={"color-white"}
              style={{ color: "aliceblue", fontWeight: 700 }}
            ></Modal.Title>
          </Modal.Header>
          <Modal.Body className="err-model-body">
            <div className="form-group">
              <label className="mont-font fw-600 font-xsss color-white">
                Waiting for the host to start the traning, please standby !
              </label>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="tr-popup-btn"
              onClick={() => checkMeetingStatus()}
            >
              Try Again
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </LoadingOverlay>
  );
};

export default PublicConferencePage;
